enum RefresherStatus {
    created = 'created',
    active = 'active',
    stopped = 'stopped',
}
export class RefreshSignaler {
    private interval: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private action: () => any;
    public status: RefresherStatus;

    constructor(actionCreator: () => Promise<unknown>, timeout: number, errorHandler?: () => void) {
        this.action = () => {
            this.status = RefresherStatus.active;
            return actionCreator().catch(() => {
                this.stop();
                return errorHandler();
            });
        };
        this.interval = window.setInterval(this.action, timeout);
    }

    refresh() {
        this.action();
    }

    stop() {
        clearInterval(this.interval);
        this.status = RefresherStatus.stopped;
    }
}

let previousSignaler;

export function wrapActionCreator(actionCreator: () => Promise<unknown>, timeout = 8000): Promise<RefreshSignaler> {
    return actionCreator().then(() => {
        if (previousSignaler) {
            previousSignaler.stop();
        }
        previousSignaler = new RefreshSignaler(actionCreator, timeout);
        return previousSignaler;
    });
}

let healthCheckSignaler;

export function healthCheckRefresher(
    promisedAction: () => Promise<unknown>,
    errorHandler?: () => void
): Promise<RefreshSignaler> {
    if (healthCheckSignaler) {
        healthCheckSignaler.stop();
    }

    return promisedAction().then(() => {
        healthCheckSignaler = new RefreshSignaler(promisedAction, 30000, errorHandler);
        return healthCheckSignaler;
    });
}

export function stopHealthCheckRefresher() {
    if (healthCheckSignaler) {
        healthCheckSignaler.stop();
    }
}
